import { client } from "api";
import { SerialEntity } from "models/Checklist";

export type EditSerialEntityRequest = Pick<
  SerialEntity,
  | "id"
  | "serialNumber"
  | "maker"
  | "model"
  | "macAddress"
  | "macAddressWifi"
  | "networkSocket"
  | "theftProtection"
  | "ipAddress"
  | "other"
  | "macAddressWifi"
  | "ipAddress"
  | "theftProtection"
  | "username"
  | "password"
>;

export type EditSerialEntityResponse = SerialEntity;

export const editSerialEntity = (request: EditSerialEntityRequest) =>
  client
    .patch<EditSerialEntityResponse>(`/checklist/serialEntity`, request)
    .then((res) => res.data);
